import { useState, useEffect } from "react";
import { getStoreSettings } from "../api/store";

export function useStoreSettings() {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getStoreSettings()
            .then(setSettings)
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    const getShippingCost = (cartTotal, methodId = null, zone = null) => {
        if (!settings) return 0;
        const methods = settings.shipping_methods;
        if (!methods?.length) return 0;

        const method = methodId
            ? methods.find(
                  (m) => m.id === methodId && (!zone || m.zone === zone),
              )
            : methods[0];

        if (!method) return 0;
        if (method.type === "free_shipping") {
            return cartTotal >= (method.min_amount || 0)
                ? 0
                : (method.cost ?? 0);
        }
        if (method.type === "flat_rate") return method.cost;
        return 0;
    };

    // Returns { subtotalTax, shippingTax, totalTax }
    const getTaxBreakdown = (subtotal, shippingCost) => {
        if (!settings?.tax_enabled)
            return { subtotalTax: 0, shippingTax: 0, totalTax: 0 };
        const rate = settings.tax_rate / 100;
        const subtotalTax = subtotal * rate;
        // WooCommerce taxes shipping if 'woocommerce_shipping_tax_class' is set
        const shippingTax = settings.shipping_taxable ? shippingCost * rate : 0;
        return {
            subtotalTax,
            shippingTax,
            totalTax: subtotalTax + shippingTax,
        };
    };

    // Get default shipping method — prefer free if applicable
    const getDefaultShipping = (cartTotal) => {
        if (!settings?.shipping_methods?.length) return null;
        const free = settings.shipping_methods.find(
            (m) =>
                m.type === "free_shipping" && cartTotal >= (m.min_amount || 0),
        );
        return free || settings.shipping_methods[0];
    };

    return {
        settings,
        loading,
        getShippingCost,
        getTaxBreakdown,
        getDefaultShipping,
    };
}
